import axios from "axios";
import store from "../store";
import config from "../config";
//import userManager from '../utils/userManager';

class Api {
   constructor() {
      this.api = axios.create({
         baseURL: config.get("api_url"),
         headers: { "Content-Type": "application/json", authorization: "token" }
      });
      //this.api.interceptors.response.use(this.interceptorsOnSuccess, this.interceptorsOnRejected);
   }
   // interceptorsOnSuccess(resp) {
   //    store.dispatch({ type: "CONNECTION_OK" });
   //    return resp;
   // }
   // interceptorsOnRejected(error) {
   //    const { response } = error;
   //    if (!response) {
   //       store.dispatch({ type: "CONNECTION_FAILD" });
   //       return Promise.reject(error);
   //    }
   //    if ([403, 401].includes(response.status)) {
   //       userManager.removeUser();
   //    }
   //    return Promise.reject(error);
   // }
   setHeaders() {
      const user = store.getState().oidc.user;
      const token = user ? user.access_token : "";
      this.api.defaults.headers["authorization"] = `Bearer ${token}`;
   }

   getTasks(params) {
      this.setHeaders();
      return this.api.get(
         `zadania?uid=${params.userId}&data=${params.date}&kodProduktu=${params.productKey}`
      );
   }

   getTask() {
      this.setHeaders();
      return this.api.get("zadanie");
   }

   init() {
      this.setHeaders();
      return this.api.get("/init");
   }

   initSchedule(productKey, date) {
      this.setHeaders();
      return this.api.get(`/?kodProduktu=${productKey}&data=${date}`);
   }

   createAnimator(data) {
      this.setHeaders();
      return this.api.post("/animator", data);
   }

   createTask(data) {
      this.setHeaders();
      return this.api.post("/zadanie", data);
   }

   editAnimator(params) {
      this.setHeaders();
      return this.api.put("animator", params);
   }

   editTask(id, data) {
      this.setHeaders();
      return this.api.put(`/zadanie?zadanieID=${id}`, data);
   }

   deleteAnimator(id) {
      this.setHeaders();
      return this.api.delete(`/animator?uzytkownikId=${id}`);
   }

   deleteTask(id) {
      this.setHeaders();
      return this.api.delete(`/zadanie?zadanieID=${id}`);
   }

   copyScheduleWeek(data) {
      this.setHeaders();
      return this.api.post("/kopiuj", data);
   }

   clearScheduleWeek(data) {
      this.setHeaders();
      return this.api.post("/wyczysc", data);
   }

   moveTask(data) {
      this.setHeaders();
      return this.api.post("/zadanie/przenies", data);
   }

   getAnimationSchedule(productKey, date) {
      this.setHeaders();
      return this.api.get(`/animacje?kodProduktu=${productKey}&data=${date}`);
   }

   deleteAnimation(id) {
      this.setHeaders();
      return this.api.delete(`/animacja?animacjaID=${id}`);
   }

   createAnimation(data) {
      this.setHeaders();
      return this.api.post("/animacja", data);
   }

   editAnimation(data) {
      this.setHeaders();
      return this.api.put("/animacja", data);
   }

   getTaskInit(productKey, date, type) {
      this.setHeaders();
      return this.api.get(`/zadanie?kodProduktu=${productKey}&data=${date}&typ=${type}`);
   }

   setLeadingDay(data) {
      this.setHeaders();
      return this.api.post("/dzienWiodacy", data);
   }

   getPrintHotels(productKey, date) {
      this.setHeaders();
      return this.api.get(`/wydruk/hotele?kodProduktu=${productKey}&data=${date}`);
   }

   initWelcomePdf(data) {
      this.setHeaders();
      return this.api.post("/wydruk/serdeczniewitamy", data);
   }

   initFlightPdf(data) {
      this.setHeaders();
      return this.api.post("/wydruk/wylotowka", data);
   }

   initWelcomeEnvelopePdf(data) {
      this.setHeaders();
      return this.api.post("/wydruk/kopertapowitalna", data, {
         responseType: "blob",
         headers: { Accept: "application/pdf" }
      });
   }


   savePrint(data) {
      this.setHeaders();
      return this.api.post("/wydruk", data);
   }

   generateReport(data) {
      this.setHeaders();
      return this.api.post(`/zadania-raport`, data, {
         responseType: "blob",
         headers: { Accept: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" }
      });
   }

   copySchedule(data) {
      this.setHeaders();
      return this.api.post("/kopiuj-dni", data);
   }

   copyScheduleVerification(data) {
      this.setHeaders();
      return this.api.post("/weryfikuj-kopiuj-dni", data);
   }
}

export default Api;
